import React from 'react';
import SettingAccount from '../components/setting/SettingAccount';

const SettingAccontPage: React.FC = () => {
  return (
    <div className="app-container">
        <SettingAccount />
    </div>
  );
};

export default SettingAccontPage;